<template>
    <div>
        <div class="day">
            <h1 class="day__info">
                <span class="day__name">
                    {{ split_day_string[0] }}
                </span>

                <span class="day__number">
                    {{ split_day_string[1] }}
                </span>

                <span class="day__month">
                    {{ split_day_string[2] }}
                </span>
            </h1>

            <h4 class="day__time">
                {{ timeString }}
            </h4>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";
    
    export default {
        props: ['day'],

        computed: {
            dayString() {
                return moment(this.day.date, SERVER_DATE_FORMAT).format("dddd Do MMMM");
            },

            timeString() {
                return moment(this.day.start_time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT) 
                    + " - " 
                    + moment(this.day.end_time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT);
            },

            split_day_string() {
                return this.dayString.split(" ");
            }
        }
    }
</script>

<style scoped lang="scss">
    .day {
        // border-top: 1px dashed #e6e6e6;
        //padding-top: 1rem;
        margin-bottom: 1rem;

        &__title{
            font-weight: 500;
        }
        &__body {
            margin-bottom: 5px;
        }

        &__info {
            @include font-itinerary-day;
            line-height: 0.8;

            span {
                display: block;
            }
        }

        &__name {
            font-style: italic;
            font-weight: 200;
        }

        &__number {
            text-transform: uppercase;
        }

        &__month {
            text-transform: uppercase;
        }

        &__time {
            color: $color-light-blue;
            font-weight: 200;
            margin-top: 20px;
            @include font-h3;
        }
    }
</style>
